import { render, staticRenderFns } from "./manage-clinics-page.vue?vue&type=template&id=56450292&scoped=true"
import script from "./manage-clinics-page.vue?vue&type=script&lang=js"
export * from "./manage-clinics-page.vue?vue&type=script&lang=js"
import style0 from "./manage-clinics-page.vue?vue&type=style&index=0&id=56450292&prod&scoped=true&lang=css"
import style1 from "./manage-clinics-page.vue?vue&type=style&index=1&id=56450292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56450292",
  null
  
)

export default component.exports